import {
  Input,
  Form,
  Switch,
  InputNumber,
  Select,
  Button,
  Divider,
  Popconfirm,
  Image,
  UploadFile,
  message,
  Tooltip,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import {
  ColorHelper,
  ColorProp,
} from '../../../../Models/Devices/ColorOptions';
import {
  DeleteOutlined,
  PlusOutlined,
  UploadOutlined,
  BarcodeOutlined,
} from '@ant-design/icons';

import style from './EditNotificationSensorNumber.module.css';

import { AddSpecialFunction } from '../AddSpecialFunction/AddSpecialFunction';
import { ResultAddFunction } from '../../../../Enums/ResultAddFunction';
import { IConnectedSensor } from '../../../../Models/Devices/IConnectedSensor';
import { DbConnectedSensorBoolean } from '../../../../Models/Devices/DbConnectedSensorBoolean';
import { ImageGallery } from '../../../ImageGallery/ImageGallery';
import { DbImageData } from '../../../../Models/ImageData/DbImageData';
import { HttpHelper } from '../../../../Helpers/HttpHelper';
import { DbConnectedSensorNumber } from '../../../../Models/Devices/DbConnectedSensorNumber';
import CustomSelecter from '../../../CustomSelecter/CustomSelecter';
import { Transput } from '../../../../Models/Platform/Transput';
import { NotificationDevice } from '../../../../Models/Devices/NotificationDevice';
import { DataType } from '../../../../Models/Platform/DataType';

const CustomColorBlock = (props: { color: ColorProp }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <div
        style={{
          marginTop: 'auto',
          marginBottom: 'auto',
          marginRight: 10,
          height: 10,
          width: 10,
          borderRadius: 3,
          backgroundColor: props.color.ColorCode,
        }}
      ></div>
      <div>{props.color.ValueName}</div>
    </div>
  );
};

export const EditNotificationSensorNumber = forwardRef(
  (
    props: {
      allData?: DbConnectedSensorNumber[];
      data?: DbConnectedSensorNumber;
      dataDevice?: NotificationDevice;
      dataTransputs: Transput[];
      imageData?: DbImageData[];
      onCancel: Function;
      onRemove: Function;
      onSafe: Function;
    },
    ref,
  ) => {
    const { t, i18n } = useTranslation();
    const [form] = Form.useForm();

    const [connectedSensor, setConnectedSensor] =
      useState<DbConnectedSensorNumber>();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [isModalUploadOpen, setIsModalUploadOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      SafeSensor() {
        if (connectedSensor) {
          form.submit();
          form.validateFields({ validateOnly: true }).then(
            (values: DbConnectedSensorNumber) => {
              values.id = connectedSensor.id;
              values.imageData = connectedSensor.imageData;
              var newObj: DbConnectedSensorNumber = Object.assign(
                new DbConnectedSensorNumber(),
                values,
              );

              props.onSafe(newObj);
            },
            () => {
              props.onSafe(null);
            },
          );
        }
      },
    }));

    useEffect(() => {
      form.resetFields();
      setConnectedSensor(props.data);
    }, [form, props.data, connectedSensor]);

    const onFinishForm = (item: DbConnectedSensorNumber) => {
      props.onSafe(item);
    };

    const onFinishFormFailed = (errorInfo: any) => {};

    const checkLabelExist = (_: any, value: string) => {
      var foundItem = props.allData?.find((x) => x.moduleName === value);
      if (foundItem !== undefined) {
        if (foundItem.sensorId === props.data?.sensorId) {
          return Promise.resolve();
        }
        return Promise.reject(new Error(t('namealreadyexist')));
      }
      return Promise.resolve();
    };

    const messageValidation = () => {
      return t('fillTheField').toString();
    };

    const GetAvailableColors = () => {
      var colors = ColorHelper.GetColors();
      return colors.map((color) => {
        return {
          value: color.KeyName,
          label: <CustomColorBlock color={color}></CustomColorBlock>,
        };
      });
    };

    const onConfirmRemove = () => {
      props.onRemove(connectedSensor);
    };

    const ChooseFunction = (result: ResultAddFunction) => {
      if (!connectedSensor) {
        return;
      }

      setIsModalOpen(false);
    };

    const ShowUpload = () => {
      setIsModalUploadOpen(true);
    };

    const ChooseImage = (file: DbImageData) => {
      if (!connectedSensor) {
        return;
      }

      connectedSensor.imageData = file;
      setConnectedSensor(connectedSensor);
      setIsModalUploadOpen(false);
    };

    const SetTransputId = (id: string) => {
      if (!connectedSensor) {
        return;
      }
      form.setFieldValue('sensorId', id)
      connectedSensor.sensorId = id;
      setConnectedSensor(connectedSensor);
    };

    const SetNameOfDevice = () => {
      if (props.dataDevice?.moduleName) {
        return props.dataDevice?.moduleName;
      }
      return '';
    };

    const GetSensorId = () => {
      console.log('connectedSensor', connectedSensor?.sensorId);
      if (connectedSensor?.sensorId == null) {
        return undefined;
      }
      return connectedSensor.sensorId;
    }

    const GetTransputs = () => {
      if (props.dataTransputs == null) {
        return [];
      }
      return props.dataTransputs.filter(x => x.dataType === DataType.Number);
    }
      
    return (
      <>
        {/* <AddSpecialFunction
          open={isModalOpen}
          sensor={connectedSensor}
          onCancel={() => setIsModalOpen(false)}
          onChoose={ChooseFunction}
        ></AddSpecialFunction> */}
        <ImageGallery
          open={isModalUploadOpen}
          onCancel={() => setIsModalUploadOpen(false)}
          onChooseFuncEnabled={true}
          onChoose={ChooseImage}
        ></ImageGallery>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
          className={style.devider}
        >
          <Divider
            style={{
              marginRight: 10,
            }}
            // orientation="left"
            // orientationMargin="250"
          >
            {t('edit')}
          </Divider>
          <Button
            style={{ marginTop: 12, marginLeft: 10, width: '50px' }}
            icon={
              <Popconfirm
                title={t('removeSensor')}
                description={t('areYouSure')}
                onConfirm={onConfirmRemove}
                okText={t('yes')}
                cancelText={t('no')}
              >
                <DeleteOutlined style={{ paddingLeft: 6, paddingRight: 6 }} />
              </Popconfirm>
            }
          ></Button>
          <Button
            style={{ marginTop: 12, marginLeft: 20, width: '50px' }}
            onClick={() => setIsModalOpen(true)}
            icon={<PlusOutlined style={{ paddingLeft: 6, paddingRight: 6 }} />}
          ></Button>
        </div>

        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={connectedSensor}
          onFinish={onFinishForm}
          onFinishFailed={onFinishFormFailed}
          autoComplete="off"
          form={form}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Form.Item
              style={{ width: 540 }}
              label={t('moduleName')}
              name="moduleName"
              key="moduleName"
              rules={[{ required: true, message: t('fillField').toString() }]}
            >
              <Input />
            </Form.Item>
            <Tooltip title={t('copyFromDevice')}>
              <Button
                onClick={() =>
                  form.setFieldValue('moduleName', SetNameOfDevice())
                }
                style={{ marginLeft: 10 }}
                icon={<BarcodeOutlined />}
              ></Button>
            </Tooltip>
          </div>
          <Form.Item
            label={t('sensorName')}
            name="sensorName"
            key="sensorName"
            rules={[{ required: true, message: messageValidation() }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t('sensorId')}
            name="sensorId"
            key="sensorId"
            rules={[
              { required: true, message: messageValidation() },
              { validator: checkLabelExist },
            ]}
          >
            <CustomSelecter
              id={GetSensorId()}
              transputs={GetTransputs()}
              setTransputId={SetTransputId}
            ></CustomSelecter>
          </Form.Item>
          <Form.Item
            label={t('visibleEnvironment')}
            name="visible"
            key="visible"
            valuePropName="checked"
            rules={[{ required: true, message: messageValidation() }]}
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label={t('showNotification')}
            name="showNotification"
            key="showNotification"
            valuePropName="checked"
            rules={[{ required: true, message: messageValidation() }]}
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label={t('switchInputValue')}
            name="switchInputValue"
            key="switchInputValue"
            valuePropName="checked"
            rules={[{ required: true, message: messageValidation() }]}
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label={t('image')}
            name="imageData"
            key="imageData"
            rules={[{ required: connectedSensor?.imageData === undefined }]}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              {connectedSensor?.imageData && (
                <Image
                  width={50}
                  src={
                    HttpHelper.GetUrlStorageBaseApi() +
                    connectedSensor?.imageData?.urlLocationOnServer
                  }
                />
              )}
              <Button
                icon={<UploadOutlined />}
                onClick={() => ShowUpload()}
                type="primary"
              >
                {t('selectOtherImage')}
              </Button>
            </div>
          </Form.Item>

          <Form.Item
            label={t('messageByHigherThen')}
            name="messageByHigherThen"
            key="messageByHigherThen"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t('reactionTimeForHigherThen') + ' (1-10)'}
            name="reactionTimeForHigherThen"
            key="reactionTimeForHigherThen"
            rules={[{ required: true }]}
          >
            <InputNumber min={1} max={10} />
          </Form.Item>
          <Form.Item
            label={t('thresholdForHigherThen')}
            name="tresholdForHigherThen"
            key="tresholdForHigherThen"
            rules={[{ required: true }]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label={t('colorForValueHigherThen')}
            name="colorForValueHigherThen"
            key="colorForValueHigherThen"
            rules={[{ required: true }]}
          >
            <Select options={GetAvailableColors()}>
              <Select.Option value="demo">Demo</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label={t('messageByLowerThen')}
            name="messageByLowerThen"
            key="messageByLowerThen"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t('reactionTimeForLowerThen') + ' (1-10)'}
            name="reactionTimeForLowerThen"
            key="reactionTimeForLowerThen"
            rules={[{ required: true }]}
          >
            <InputNumber min={1} max={10} />
          </Form.Item>
          <Form.Item
            label={t('thresholdForLowerThen')}
            name="thresholdForLowerThen"
            key="thresholdForLowerThen"
            rules={[{ required: true }]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label={t('colorForValueLowerThen')}
            key="colorForValueLowerThen"
            name="colorForValueLowerThen"
            rules={[{ required: true }]}
          >
            <Select options={GetAvailableColors()}>
              <Select.Option value="demo">Demo</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </>
    );
  },
);
